module.exports = __webpack_public_path__ + "img/iconUp.b2a5b070.svg";